import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const GOAL_CATEGORIES = {
    GENERAL: 'General',
    CAREER: 'Career',
    HEALTH: 'Health & Fitness',
    RELATIONSHIPS: 'Relationships',
    LEARNING: 'Learning & Education',
    BUCKET_LIST: 'Bucket List'
};

const EditGoalModal = ({ show, handleClose, goal, onUpdateGoal, onDeleteGoal }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('GENERAL');
    const [targetDate, setTargetDate] = useState('');

    useEffect(() => {
        if (goal) {
            setTitle(goal.title || '');
            setDescription(goal.description || '');
            setCategory(goal.category || 'GENERAL');
            setTargetDate(goal.target_date ? goal.target_date.split('T')[0] : '');
        }
    }, [goal]);

    const handleUpdate = () => {
        const goalData = {
            title,
            description,
            category,
            target_date: targetDate || null
        };
        onUpdateGoal(goal.id, goalData);
        handleClose();
    };

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this goal?')) {
            onDeleteGoal(goal.id);
            handleClose();
        }
    };

    if (!goal) return null;

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Goal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Goal Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="Enter goal title"
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter goal description"
                        />
                    </Form.Group>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                >
                                    {Object.entries(GOAL_CATEGORIES).map(([key, name]) => (
                                        <option key={key} value={key}>{name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Target Date (Optional)</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={targetDate}
                                    onChange={(e) => setTargetDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleDelete} className="me-auto">
                    Delete Goal
                </Button>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button variant="success" onClick={handleUpdate} disabled={!title.trim()}>
                    Update Goal
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditGoalModal;
